"use client";

import { c as _c } from "react/compiler-runtime";
import { type FragmentOfShopifyStorefront, readFragmentShopifyStorefront } from "@repo/graphql-shopify-storefront";
import type { Route } from "next";
import { useParams, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { RefineByListItem } from "#/components/molecules/search-refinements/refine-by-list-item";
import { Collection_Fragment } from "#/graphql/shopify-storefront/fragments";
export function RefineByFilterByPathItem(t0) {
  const $ = _c(13);
  const {
    collectionMasked
  } = t0;
  let t1;
  if ($[0] !== collectionMasked) {
    t1 = readFragmentShopifyStorefront(Collection_Fragment, collectionMasked);
    $[0] = collectionMasked;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  const params = useParams();
  const currentSearchParams = useSearchParams();
  const searchParams = new URLSearchParams(currentSearchParams);
  const title = collection.title;
  const [active, setActive] = useState(params?.collection === collection.handle);
  let t2;
  if ($[2] !== collection.handle || $[3] !== params?.collection) {
    t2 = () => {
      setActive(params?.collection === collection.handle);
    };
    $[2] = collection.handle;
    $[3] = params?.collection;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== collection.handle || $[6] !== params) {
    t3 = [collection.handle, params];
    $[5] = collection.handle;
    $[6] = params;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  searchParams.delete("q");
  const T0 = RefineByListItem;
  const t4 = `/search/${collection.handle}?${searchParams.toString()}` as Route;
  let t5;
  if ($[8] !== T0 || $[9] !== active || $[10] !== t4 || $[11] !== title) {
    t5 = <T0 active={active} href={t4} title={title} />;
    $[8] = T0;
    $[9] = active;
    $[10] = t4;
    $[11] = title;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}